import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import UnitRelationListRow from "./UnitRelationListRow";
import { useGetList } from "../../../../hooks/useGetList";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const UnitRelationList = () => {
  const { id } = useParams();
  const { selectedBranch } = useSelector((state) => state.filterItemUnit);

  const {
    data: unitRelations,
    loading,
    refetch,
  } = useGetList(
    `unit-relation?relatedItem=${id}&relatedBranch=${selectedBranch}`,
    selectedBranch ? true : false,
  );

  const { refresh } = useSelector((state) => state.refresh);

  useEffect(() => {
    if (selectedBranch) {
      refetch();
    }
  }, [refresh, selectedBranch]);

  return (
    <Paper elevation={2} sx={{ width: "100%", overflow: "hidden", mt: 3 }}>
      <Box sx={{ p: 3, borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>
        <Typography variant="h6" component="div">
          Unit Relations
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Manage unit conversion relationships and ratios
        </Typography>
      </Box>

      <TableContainer>
        <Table stickyHeader aria-label="unit relations table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, minWidth: 50 }}>ID</TableCell>
              <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                From Unit
              </TableCell>
              <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>
                From Qty
              </TableCell>
              <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                To Unit
              </TableCell>
              <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>
                To Qty
              </TableCell>

              <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                Created
              </TableCell>
              <TableCell
                sx={{ fontWeight: 600, minWidth: 120, textAlign: "center" }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              // Skeleton loaders for loading state
              Array.from({ length: 5 }).map((_, index) => (
                <TableRow key={`skeleton-${index}`}>
                  <TableCell>
                    <Skeleton variant="text" width={40} height={32} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={120} height={32} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={100} height={32} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={120} height={32} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={100} height={32} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={100} height={32} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={120} height={32} />
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 0.5,
                      }}
                    >
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="circular" width={32} height={32} />
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : unitRelations?.data?.length === 0 ? (
              // Empty state when no data
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      gutterBottom
                    >
                      No unit relations found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      There are currently no unit relations available. Add your
                      first unit relation to get started.
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              // Actual data when available
              unitRelations?.data?.map((row, index) => (
                <UnitRelationListRow key={row.id} row={row} index={index} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default UnitRelationList;
